import * as angular from 'angular';
import * as _ from 'lodash';
import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import template from './editPalletKpi.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, ReportServiceName];

export interface EditPalletKpiParams {
  plant: Plant;
  productionDate: Date;
  palletKpiItem: apsViewModels.PlantKpiItem;
}

export function openEditPalletKpi(data: EditPalletKpiParams,
  $modal: mm.foundation.modal): angular.IPromise<apsViewModels.PlantKpiItem> {
  return $modal.open({
    template: template,
    controller: 'EditPalletKpiCtrl as vm',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

interface EditPalletKpi {
  shops: apsViewModels.ShopNavigation[];
  originalKpi: apsViewModels.PlantKpiItem;
  palletKpiCommand: apsCommands.UpdatePlantKpi;
  form: angular.IFormController;
  palletQuantity: number;
  save(): void;
  cancel(): void;  
  goodBottles(): number;
  onValueChange(inputModel: string):void;
  packedGlass(): number;
  meltedGlass(): number;
  ptm(): number;
  ptp(): number;
}

export default angular.module('aps.controller.editPalletKpi', requires)
  .controller('EditPalletKpiCtrl', editPalletKpi)
  .name;

function editPalletKpi(
  reportService: ReportService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  data: EditPalletKpiParams,
  $modalInstance: mm.foundation.modalInstance): EditPalletKpi {
  let vm = {} as EditPalletKpi;

  vm.shops = data.plant.shops;

  vm.save = save;
  vm.cancel = cancel;
  vm.goodBottles = goodBottles;
  vm.onValueChange = onValueChange;
  vm.packedGlass = packedGlass;
  vm.meltedGlass = meltedGlass;
  vm.ptm = ptm;
  vm.ptp = ptp;
  
  if (data.palletKpiItem) {
    vm.originalKpi = data.palletKpiItem;
    vm.palletQuantity = data.palletKpiItem.goodBottles / (data.palletKpiItem.goodPallets + data.palletKpiItem.heldPallets - data.palletKpiItem.reintroducedPallets);
    vm.palletKpiCommand = {
      id: data.palletKpiItem.id,
      plantId: data.plant.id,
      speed: Math.round(data.palletKpiItem.speed),
      weight: data.palletKpiItem.weight,
      goodPallets: data.palletKpiItem.goodPallets,
      heldPallets: data.palletKpiItem.heldPallets,
      reintroducedPallets: data.palletKpiItem.reintroducedPallets,
      goodBottles : data.palletKpiItem.goodBottles,
      heldBottles : data.palletKpiItem.heldBottles,
      reintroducedBottles : data.palletKpiItem.reintroducedBottles,
      totalMinutes : data.palletKpiItem.totalMinutes,
      meltedGlass : data.palletKpiItem.meltedGlass,
      currentjci: data.palletKpiItem.jci,
      previousjci: data.palletKpiItem.jci,
      updateRaw: false
    };
  }
  return vm;

  function goodBottles() {
    return (vm.palletKpiCommand.goodPallets + vm.palletKpiCommand.heldPallets - vm.palletKpiCommand.reintroducedPallets)
      * vm.palletQuantity;
  }

  function onValueChange(inputModel:string) : void{

    vm.palletKpiCommand.updateRaw = true;

    if (inputModel == 'goodPallets'){   
      vm.palletKpiCommand.goodBottles = null;
    }
    else if (inputModel == 'heldPallets'){
      vm.palletKpiCommand.heldBottles = null;
    }
    else if (inputModel == 'reintroducedPallets'){
      vm.palletKpiCommand.reintroducedBottles = null;
    }
  }

  function packedGlass() {
    return roundDecimal(goodBottles() * vm.palletKpiCommand.weight);
  }

  function meltedGlass() {
    return roundDecimal(((vm.palletKpiCommand.totalMinutes - vm.originalKpi.streamingDowntimeMinutes) * vm.palletKpiCommand.weight * vm.palletKpiCommand.speed) + (vm.originalKpi.streamingDowntimeTons*32000));
  }

  function ptm() {
    return roundDecimal((packedGlass() / meltedGlass()) * 100.0);
  }

  function ptp() {
    return roundDecimal((packedGlass() / meltedGlass()) * 100.0);
  }

  function roundDecimal(value: number) {
    return Math.round(value * 100.0) / 100.0;
  }

  function save(): void {
    if (vm.form.$invalid) {
      return;
    }
   
    loaderService.loadingPromise(
      reportService.updatePlantKpi(vm.palletKpiCommand)
        .then(() => $modalInstance.close({
          ...vm.originalKpi,
          ...vm.palletKpiCommand,
          goodBottles: vm.palletKpiCommand.goodBottles,
          heldBottles: vm.palletKpiCommand.heldBottles,
          reintroducedBottles: vm.palletKpiCommand.reintroducedBottles,
          packedGlass: packedGlass(),
          meltedGlass: meltedGlass(),
          ptm: ptm(),
          ptp: ptp()
        }), notifyService.handleApiErrors));
  }

  function cancel(): void {
    $modalInstance.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/controllers/reports/editPalletKpi.controller.ts